import { cca_config } from '@/plugins/cca-config'

// Demandes de rendez-vous des sites (be_clinique, routes /rendez-vous/demandes-web).
// Désactivées tant que RDV_WEB_ENABLED n'est pas à true dans public/env.json : aucun appel n'est alors émis
// (le serveur répond 503 tant que RDV_WEB_ENABLED n'y est pas activé non plus).
// Lu à l'appel : env.json est chargé au démarrage, après l'import des modules.
export function rdvWebActif() {
    return cca_config.RDV_WEB_ENABLED === true || cca_config.RDV_WEB_ENABLED === 'true'
}
